import * as React from 'react';
import { Link } from 'react-router';
import styled from 'styled-components';
import { rem } from 'polished';
import { TextP } from '../../Defaults/Text';
import {
  FlexCol,
  FlexRow,
  FlexRowCenter,
  FlexRowCenterVertical,
} from '../../Defaults/Flexbox/Flexbox';
import { __ } from 'react-i18n';
import { SvgIcon, IconType } from '../General/SvgIcon';

export interface Props {
  address: string;
  phone: string;
  fax: string;
  email: string;
  ico: string;
  icdph: string;
  orsr: string;
}

function ContactUpper({ address, phone, fax, email, ico, icdph, orsr }: Props) {
  return (
    <Wrapper>
      <LeftWrapper>
        <Name>{address}</Name>
        <ValueWrapper>
          <ValueName>{__('Tel. číslo')}</ValueName>
          <Phone>{phone}</Phone>
        </ValueWrapper>
        <ValueWrapper>
          <ValueName>{__('Fax')}</ValueName>
          <Email>{fax}</Email>
        </ValueWrapper>
        <ValueWrapper>
          <ValueName>{__('Email')}</ValueName>
          <Email>{email}</Email>
        </ValueWrapper>
      </LeftWrapper>
      <RightWrapper>
        <ValueWrapper>
          <ValueName>{__('IČO')}</ValueName>
          <Email>{ico}</Email>
        </ValueWrapper>
        <ValueWrapper>
          <ValueName>{__('IČ DPH')}</ValueName>
          <Email>{icdph}</Email>
        </ValueWrapper>
        <OrsrValueName>{__('Výpis z OR SR')}</OrsrValueName>
        <Email>{orsr}</Email>
      </RightWrapper>
    </Wrapper>
  );
}

const Wrapper = styled(FlexRow)`
  width: 100%;
  margin-bottom: ${rem(24)};

  ${({ theme }) => theme.mediab.l925`
    flex-flow: column;
    margin: 0;
  `}
`;

const RightWrapper = styled(FlexCol)`
  max-width: ${rem(328)};
  width: 100%;
`;

const LeftWrapper = styled(FlexCol)`
  margin-right: ${rem(32)};
  max-width: ${rem(328)};
  width: 100%;

  ${({ theme }) => theme.mediab.l925`
    margin: ${rem(32)} 0;
  `}
`;

const Text = styled(TextP)`
  color: ${({ theme }) => theme.colors.textPrimary};
  line-height: ${rem(22)};
  font-family: ${({ theme }) => theme.font.secondary};
  font-weight: 400;
  font-size: ${rem(14)};
`;

const Name = styled(Text)`
  margin-bottom: ${rem(32)};
`;

const Phone = styled(Text)``;

const Email = styled(Text)`
  font-weight: 400;
`;

const ValueWrapper = styled(FlexRowCenterVertical)`
  margin-bottom: ${rem(4)};

  &:last-child {
    margin: 0;
  }
`;

const ValueName = styled(Text)`
  width: ${rem(60)};
  margin-right: ${rem(24)};
  font-weight: 400;
`;

const OrsrValueName = styled(ValueName)`
  margin-top: ${rem(24)};
  width: initial;
`;

export { ContactUpper };
